import axios from "axios";
import { toast } from "react-toastify";
import { OutputDTO } from "./swagger";
import { getBrowserId } from "../helpers/browser";

export function setupInterceptors() {
  axios.interceptors.request.use((config) => {
    config.headers.Authorization = `Bearer ${localStorage.getItem(
      "authToken"
    )}`;
    config.headers["Accept-Language"] =
      localStorage.getItem("language") || "en";
    config.headers["browser-id"] = getBrowserId();
    return config;
  });

  axios.interceptors.response.use(
    (res) => {
      if (res?.data?.success && res?.data?.message) {
        toast(res.data.message, { type: "success" });
      }
      return res;
    },
    (err) => {
      if (err?.response?.data) {
        const data = err.response.data as OutputDTO;
        if (data.data?.otpReset) {
          localStorage.removeItem("authToken");
          window.location.href = window.location.origin;
        }
        if (data.data?.sessionInvalid) {
          // The account behind the token no longer exists (e.g. deleted by
          // an admin). Drop the dead token and leave protected pages. On
          // auth pages just clear quietly; no redirect mid-form.
          if (localStorage.getItem("authToken")) {
            localStorage.removeItem("authToken");
            const path = window.location.pathname;
            const onAuthPage = ["/login", "/register", "/account", "/setup"]
              .some((p) => path.startsWith(p));
            if (!onAuthPage) {
              window.location.href = window.location.origin;
            }
          }
        }
        if (
          data.error?.message &&
          !data.error?.ignore &&
          (err.response.status !== 401 || err.config?.toastOn401)
        )
          toast(data.error.message, { type: "error" });
      }
      // Opt-in: some callers (e.g. register → 409 redirect) need to see the
      // failure in their own error handlers; default stays swallow-and-toast
      // because most call sites branch on res?.data?.success instead.
      if ((err?.config as any)?.rethrow) return Promise.reject(err);
      // else toast("No Connection!", { type: "error" });
    }
  );
}
